var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#12AAFF",
    d: "m17.604 17.621-1.18 3.187a.4.4 0 0 0 0 .274l2.03 5.483 2.348-1.335-2.818-7.609a.203.203 0 0 0-.38 0m2.365-5.359a.203.203 0 0 0-.38 0l-1.18 3.187a.4.4 0 0 0 0 .274l3.326 8.976 2.348-1.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DCCED",
    d: "M16 5.487a.4.4 0 0 1 .168.043l8.953 5.09a.33.33 0 0 1 .168.286v10.18a.33.33 0 0 1-.168.286l-8.953 5.09a.33.33 0 0 1-.168.043.4.4 0 0 1-.167-.043l-8.953-5.087a.33.33 0 0 1-.168-.286v-10.18a.33.33 0 0 1 .168-.287l8.953-5.09A.35.35 0 0 1 16 5.487m0-1.487c-.318 0-.637.08-.923.244L6.124 9.334A1.81 1.81 0 0 0 5.2 10.91v10.18c0 .65.352 1.25.924 1.575l8.953 5.09a1.88 1.88 0 0 0 1.848 0l8.952-5.09a1.81 1.81 0 0 0 .923-1.575V10.91a1.81 1.81 0 0 0-.923-1.576L17.724 4.244A1.87 1.87 0 0 0 16 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213147",
    d: "m10.079 24.913.822-2.221 1.659 1.357-1.551 1.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.244 10.18h-2.268a.4.4 0 0 0-.38.263l-4.865 13.136 2.348 1.335 5.358-14.465a.2.2 0 0 0-.193-.268m3.972-.001h-2.27a.4.4 0 0 0-.38.263l-5.556 15 2.348 1.334 6.047-16.328a.2.2 0 0 0-.19-.268"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainArbitrum);
export default __webpack_public_path__ + "static/media/chain-arbitrum.19c02a863e3124937e8dd0ad3f6ab2c3.svg";
export { ForwardRef as ReactComponent };